import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { onEnterKeyPress } from 'helpers/Account';
import { mergeStyles } from 'helpers/GlobalHelper';
import {
  Events,
  getFavoritesProps,
  getSegmentFavoritesEvents,
  getSegmentModelMetadata,
  handleAnalytics,
  SegmentPageActionTypes,
  SegmentUiElements,
} from '@foxcorp/delta-web-analytics';

import Style from './Favorite.module.scss';

const TYPE_BUTTON = 'TYPE_BUTTON';
const TYPE_LINK = 'TYPE_LINK';
const TYPE_ICON = 'TYPE_ICON';
const TYPE_WATCHLIST = 'TYPE_WATCHLIST';
const TEXT_POSITION_RIGHT = 'TEXT_POSITION_RIGHT';
const TEXT_POSITION_LEFT = 'TEXT_POSITION_LEFT';

const FAVORITE_ICON = 'favorite';
const FAVORITE_ICON_FILLED = 'favorite-filled';
const FAVORITE_ICON_PLUS = 'add';
const FAVORITE_ICON_CHECKMARK = 'checkmark-thin';
const FAVORITE_ICON_PLUS_CIRCLE = 'circle-plus';
const FAVORITE_ICON_PLUS_CHECKED = 'circle-plus-checked';

const WATCHLIST_ICON_PLUS_HOVERSTATE_V2 = 'circle-plus-hover';
const WATCHLIST_ICON_PLUS_CHECKED_HOVERSTATE_V2 = 'circle-plus-checked-hover';

const HEART = 'heart';
const PLUS_CIRCLE = 'plus-circle';
const PLUS_HOVER = 'plus-hover';
export const PLUS = 'plus';

export const FAVORITE_TYPE_BUTTON = TYPE_BUTTON;
export const FAVORITE_TYPE_LINK = TYPE_LINK;
export const FAVORITE_TYPE_ICON = TYPE_ICON;
export const FAVORITE_TYPE_WATCHLIST = TYPE_WATCHLIST;
export const FAVORITE_TEXT_POSITION_RIGHT = TEXT_POSITION_RIGHT;
export const FAVORITE_PLUS = PLUS;
export const FAVORITE_PLUS_CIRCLE = PLUS_CIRCLE;
export const FAVORITE_HEART = HEART;
export const FAVORITE_PLUS_HOVER = PLUS_HOVER;

const PAGE_ITEM_TITLES = {
  ADD: 'add to watchlist',
  REMOVE: 'remove from watchlist',
};

class Favorite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isFavorite: this.isFavorite(),
    };
    this.setFavorites = this.setFavorites.bind(this);
    this.deleteFavorites = this.deleteFavorites.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { manuallySetFavorite } = this.props;
    // Fire setFavorites w/o click action from user
    if (!manuallySetFavorite && nextProps.manuallySetFavorite) {
      this.setFavorites();
    }
  }

  componentDidUpdate({ manager: prevManager }) {
    const { manager } = this.props;
    const { isFavorite } = this.state;
    if (manager?.favorites !== prevManager?.favorites) {
      const newFavorite = this.isFavorite();
      if (newFavorite !== isFavorite) {
        this.setState({ isFavorite: newFavorite });
      }
    }
  }

  trackHeroItemSelectAction = ({ item, isAddingFavorite = false }) => {
    handleAnalytics({
      event: Events.HERO_ITEM_SELECT_ACTION,
      payload: {
        page_action_type: `${isAddingFavorite ? 'add to' : 'remove from'} favorites`,
        page_collection_count: 1,
        page_item_type: 'hero',
        page_item_state: 'static image',
        page_item_container_title: item.name,
        page_item_vertical_position: '1',
        page_item_horizontal_position: '1',
        page_item_title: item.name,
        page_item_subtitle: item.description,
        page_item_cc: 'cc off',
        page_item_volume: 'volume off',
        page_playlist_length: 1,
        page_video_uid: item.latestEpisode?.uID,
        ...getSegmentModelMetadata(),
      },
    });
  };

  setFavorites(e) {
    const { isLoading } = this.state;
    const {
      data,
      isHeroItem,
      item,
      manager,
      setFavorite = _.noop,
      stopNavigationOnClick,
    } = this.props;

    if (stopNavigationOnClick) e.preventDefault();
    if (isLoading) return;
    this.setState({ isLoading: true });
    manager.setFavorites(data).then(() => {
      getSegmentFavoritesEvents().addFavorite({
        ...data,
        ...(manager.favorites && { favoritesProps: getFavoritesProps(manager.favorites) }),
        page_item_title: PAGE_ITEM_TITLES.ADD,
      });
      if (isHeroItem) this.trackHeroItemSelectAction({ item, isAddingFavorite: true });
      this.setState({ isLoading: false, isFavorite: true });
      setFavorite(true);
    });
  }

  getTypeClass() {
    const { theme, type, isEpgFavorite } = this.props;
    const { isLoading } = this.state;

    const style = mergeStyles(_.cloneDeep(Style), theme);

    const loadingClass = isLoading ? style.loading : null;
    if (isEpgFavorite) return classNames(style.epgFavorite, loadingClass);
    if (type === TYPE_BUTTON) return classNames(style.button, loadingClass);
    if (type === TYPE_ICON) return classNames(style.icon, loadingClass);
    if (type === TYPE_LINK) return classNames(style.link, loadingClass);
    if (type === TYPE_WATCHLIST) return classNames(style.watchList, loadingClass);
    return null;
  }

  isFavorite() {
    const { manager, data } = this.props;
    if (!manager || !manager.favorites) return false;
    const favoritableItems = data?.favoritableItems ?? [];
    let results = [];

    favoritableItems.forEach(item => {
      const matches = manager.favorites.filter(favorite => item.id === favorite.id);
      results = [...matches, ...results];
    });
    return results.length > 0;
  }

  deleteFavorites(e) {
    const { isLoading } = this.state;
    const {
      data,
      isHeroItem,
      item,
      manager,
      stopNavigationOnClick,
      setFavorite = _.noop,
    } = this.props;

    if (stopNavigationOnClick) e.preventDefault();
    if (isLoading) return;
    this.setState({ isLoading: true });
    manager
      .deleteFavorites({ favoriteList: [data], favoritesDetails: manager.favoritesDetails })
      .then(() => {
        getSegmentFavoritesEvents().removeFavorite({
          ...data,
          ...(manager.favorites && { favoritesProps: getFavoritesProps(manager.favorites) }),
          page_item_title: PAGE_ITEM_TITLES.REMOVE,
        });
        if (isHeroItem) this.trackHeroItemSelectAction({ item });
        this.setState({ isLoading: false, isFavorite: false });
        setFavorite(false);
      });
  }

  renderInterior() {
    const { data, defaultText, favoritedText, iconType, textPosition, type, theme } = this.props;
    const { seriesName } = data;
    const { isFavorite } = this.state;
    let onIcon = '';
    let offIcon = '';
    let viewBox = '';
    switch (iconType) {
      case PLUS:
        onIcon = FAVORITE_ICON_CHECKMARK;
        offIcon = FAVORITE_ICON_PLUS;
        viewBox = '0 0 26 26';
        break;
      case PLUS_HOVER:
        onIcon = WATCHLIST_ICON_PLUS_CHECKED_HOVERSTATE_V2;
        offIcon = WATCHLIST_ICON_PLUS_HOVERSTATE_V2;
        viewBox = isFavorite ? '0 0 26 26' : '0 0 28 28';
        break;
      case PLUS_CIRCLE:
        onIcon = FAVORITE_ICON_PLUS_CHECKED;
        offIcon = FAVORITE_ICON_PLUS_CIRCLE;
        viewBox = '0 0 26 26';
        break;
      default:
        onIcon = FAVORITE_ICON_FILLED;
        offIcon = FAVORITE_ICON;
        viewBox = '0 0 24 24';
        break;
    }
    const style = mergeStyles(_.cloneDeep(Style), theme);
    const text = isFavorite ? favoritedText : defaultText;
    const icon = isFavorite ? onIcon : offIcon;
    const optionalClass = type === TYPE_LINK ? style.optionalText : style.optional;
    const iconClasses = classNames(
      style.favoriteIcon,
      isFavorite ? style.favoriteIconFilled : '',
      isFavorite ? style.active : '',
      style[icon],
    );

    const textElement = (
      <span className={optionalClass} data-test={`favorite-text-${textPosition}`}>
        {text}
      </span>
    );

    const textTag = type === TYPE_ICON || type === TYPE_WATCHLIST ? null : textElement;
    const beforeText = textPosition === TEXT_POSITION_LEFT ? textTag : null;
    const afterText = textPosition === TEXT_POSITION_RIGHT ? textTag : null;
    const ariaLabel = `${text} ${seriesName}`;

    return (
      <div className={iconClasses}>
        {beforeText}
        <Icon
          icon={icon}
          color="white"
          data-test="favorite-icon"
          ariaLabel={ariaLabel}
          viewBox={viewBox}
          role="button"
        />
        {afterText}
      </div>
    );
  }

  render() {
    const { data, segmentPlaylistButtonAction, clickHandler, theme } = this.props;
    const favoritableItems = _.get(data, 'favoritableItems');
    if (!favoritableItems) return null;
    const { isFavorite } = this.state;

    const clickEvent = event => {
      event.stopPropagation();
      event.preventDefault();
      segmentPlaylistButtonAction({
        actionType: SegmentPageActionTypes.WATCHLIST,
        uiElement: SegmentUiElements.PLUS,
      });
      if (isFavorite) {
        this.deleteFavorites(event);
      } else {
        this.setFavorites(event);
      }

      clickHandler(event);
    };
    const style = mergeStyles(_.cloneDeep(Style), theme);
    const favoritedClass = isFavorite ? style.topButtonFavorites : '';
    const divClasses = classNames(this.getTypeClass(), favoritedClass, style.secondary);
    return (
      <button
        className={divClasses}
        onClick={clickEvent}
        onKeyPress={e => {
          onEnterKeyPress(e, clickEvent);
        }}
        data-testid="favorite-button"
      >
        {this.renderInterior()}
      </button>
    );
  }
}

Favorite.defaultProps = {
  clickHandler: () => {},
  data: {},
  defaultText: window.Language.global_favoriteButton,
  favoritedText: window.Language.global_favoriteSetButton,
  isEpgFavorite: false,
  isHeroItem: false,
  item: {},
  manuallySetFavorite: false,
  segmentPlaylistButtonAction: () => {},
  stopNavigationOnClick: false,
  textPosition: TEXT_POSITION_RIGHT,
  type: TYPE_BUTTON,
  iconType: HEART,
  theme: {},
};

Favorite.propTypes = {
  clickHandler: PropTypes.func,
  data: PropTypes.shape({}),
  defaultText: PropTypes.string,
  favoritedText: PropTypes.string,
  isEpgFavorite: PropTypes.bool,
  isHeroItem: PropTypes.bool,
  item: PropTypes.shape({}),
  manager: PropTypes.shape({
    deleteFavorites: PropTypes.func,
    favorites: PropTypes.arrayOf(PropTypes.shape({})),
    setFavorites: PropTypes.func,
  }).isRequired,
  manuallySetFavorite: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  segmentPlaylistButtonAction: PropTypes.func,
  setFavorite: PropTypes.func,
  stopNavigationOnClick: PropTypes.bool,
  textPosition: PropTypes.oneOf([TEXT_POSITION_RIGHT, TEXT_POSITION_LEFT]),
  type: PropTypes.oneOf([TYPE_BUTTON, TYPE_LINK, TYPE_ICON, TYPE_WATCHLIST]),
  iconType: PropTypes.oneOf([HEART, PLUS, PLUS_CIRCLE, PLUS_HOVER]),
  theme: PropTypes.shape({}),
};

export default Favorite;
